

export default [
  {
    path: "/",
    name: "default",
    id: 0,
    meta: {
      authRequired: false,
    },
    next: "/pby/install",
    intro: true,
    component: () => import("./views/pby/Intro"),
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  {
    path: "/pby/intro",
    name: "PBY Introduction",
    meta: { authRequired: false},
    id: 1,
    next: "/pby/install",
    intro: true,
    component: () => import("./views/pby/Intro"),
  },
  {
    path: "/pby/install",
    name: "PBY Install",
    meta: { authRequired: false},
    id: 2,
    next: "/pby/enroll",
    back: "/pby/intro",
    intro: false,
    component: () => import("./views/pby/Install"),
  },
  {
    path: "/pby/enroll",
    name: "PBY Enrollment",
    meta: { authRequired: false},
    id: 3,
    next: "/pby/setup",
    back: "/pby/install",
    intro: false,
    component: () => import("./views/pby/Enroll"),
  },
  {
    path: "/pby/setup",
    name: "PIN Setup",
    meta: { authRequired: false},
    id: 4,
    next: "/pby/test",
    back: "/pby/enroll",
    intro: false,
    component: () => import("./views/pby/Setup"),
  },
  {
    path: "/pby/test",
    name: "PBY App Testing",
    meta: { authRequired: false},
    id: 5,
    next: "/pby/intro",
    back: "/pby/setup",
    nextText: "Return to Start",
    intro: false,
    component: () => import("./views/pby/Test"),
  },

  {
    path: "/sim/intro",
    name: "Introduction",
    meta: { authRequired: false},
    component: () => import("./views/sim/SimIntro"),
  },
  {
    path: "/sim/authenticate",
    name: "Auhentication",
    meta: { authRequired: false},
    component: () => import("./views/sim/SimAuthenticate"),
  },
  {
    path: "/sim/signing",
    name: "Signing",
    meta: { authRequired: false},
    component: () => import("./views/sim/SimSigning"),
  },

];